"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var taggedTemplateLiteralLoose_1 = __importDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteralLoose"));
function _templateObject() {
    var data = taggedTemplateLiteralLoose_1.default(["\n  max-width: 400px;\n\n  p {\n    display: flex;\n\n    &:not(:last-child) {\n      margin-bottom: var(--gutter-small);\n    }\n  }\n\n  input,\n  textarea,\n  button {\n    font-family: inherit;\n    font-size: inherit;\n    border-radius: 3px;\n    border: 1px solid #777;\n\n    &:focus {\n      outline: 2px solid skyblue;\n    }\n  }\n\n  button {\n    display: inline-block;\n    padding: 0.5rem 2rem;\n  }\n\n  input,\n  textarea {\n    padding: 0.5rem;\n    flex: 1;\n  }\n\n  textarea {\n    height: 120px;\n    padding: 0.5rem;\n  }\n"]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var react_1 = require("react");
var layouts_1 = __importDefault(require("../layouts"));
var styled_1 = __importDefault(require("@emotion/styled/"));
var react_2 = require("@emotion/react");
var StyledForm = styled_1.default.form(_templateObject());
function encode(data) {
    return Object.keys(data).map(function (key) {
        var value = data[key];
        return encodeURIComponent(key) + '=' + (value === null || value === undefined ? 'null' : encodeURIComponent(value));
    }).join('&');
}
var ContactPage = function ContactPage() {
    var _useState = react_1.useState({}), state = _useState[0], setState = _useState[1];
    var handleChange = function handleChange(e) {
        var _Object$assign;
        setState(Object.assign({}, state, (_Object$assign = {
            errorMessage: undefined
        }, _Object$assign[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value, _Object$assign)));
    };
    var handleChangeTextArea = function handleChangeTextArea(e) {
        var _Object$assign2;
        setState(Object.assign({}, state, (_Object$assign2 = {}, _Object$assign2[e.target.name] = e.target.value, _Object$assign2)));
    };
    var handleSubmit = function handleSubmit(e) {
        e.preventDefault();
        var form = e.target;
        fetch('/contact/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: encode(Object.assign({
                'form-name': form.getAttribute('name'),
                'subject': "New Message from " + state.name
            }, state))
        }).then(function () {
            return setState(Object.assign({}, state, {
                messageSent: true
            }));
        }).catch(function (error) {
            return alert(error);
        });
    };
    return react_2.jsx(layouts_1.default, null, react_2.jsx("div", {
        className: "row"
    }, !state.messageSent ? react_2.jsx(StyledForm, {
        method: "POST",
        name: "contact",
        "data-netlify": "true",
        "data-netlify-honeypot": "bot-field",
        onSubmit: handleSubmit
    }, react_2.jsx("div", {
        style: {
            visibility: 'hidden'
        }
    }, react_2.jsx("label", null, "Don\u2019t fill this out if you're human: ", react_2.jsx("input", {
        name: "bot-field"
    }))), react_2.jsx("input", {
        type: "hidden",
        name: "subject",
        value: "New Message"
    }), react_2.jsx("p", null, react_2.jsx("input", {
        type: "text",
        name: "name",
        "aria-label": "Name:",
        placeholder: "Name...",
        onChange: handleChange
    })), react_2.jsx("p", null, react_2.jsx("input", {
        type: "email",
        name: "email",
        required: true,
        "aria-label": "Email",
        placeholder: "Email...",
        onChange: handleChange
    })), react_2.jsx("p", null, react_2.jsx("textarea", {
        name: "message",
        required: true,
        "aria-label": "Message",
        placeholder: "Message...",
        onChange: handleChangeTextArea
    })), react_2.jsx("p", null, react_2.jsx("label", null, react_2.jsx("input", {
        type: "checkbox",
        onChange: handleChange,
        name: "not-a-robot",
        required: true
    }), "\xA0\xA0I'm not a Robot.")), react_2.jsx("p", null, react_2.jsx("button", {
        type: "submit"
    }, "Submit"))) : react_2.jsx("p", null, "Your message has been submitted successfully.")));
};
exports.default = ContactPage;
